<template>
  <div>
    <b-alert variant="primary" show v-if="type === 'productReviewAndSellerFeedback'">
      <p><i class="mdi mdi-bullseye-arrow me-2"></i> {{ $t('components.campaign_alert.title') }}</p>
      <p>{{ $t('components.campaign_alert.default') }}</p>
      <p>{{ $t('components.campaign_alert.check_this') }}</p>
      <ul>
        <li>{{ $t('components.campaign_alert.first') }}</li>
        <li>{{ $t('components.campaign_alert.second') }}</li>
        <li>{{ $t('components.campaign_alert.third') }}</li>
      </ul>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: "CampaignAlert",
  props: ['type']
}
</script>

<style scoped>

</style>